// Environment-specific configuration
export const environmentConfig = {
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',

  analytics: {
    allowPublicAccess: false,
  },
};

export const isAnalyticsAccessible = (user?: any): boolean => {
  if (environmentConfig.analytics.allowPublicAccess) {
    return true;
  }

  if (!user) return false;

  return user.isAdmin === true;
};

export const getEnvironmentInfo = () => ({
  environment: environmentConfig.environment,
  isDevelopment: import.meta.env.DEV,
  isStaging: import.meta.env.VITE_ENVIRONMENT === 'staging',
  isProduction: import.meta.env.VITE_ENVIRONMENT === 'production',
  analyticsPublicAccess: environmentConfig.analytics.allowPublicAccess
});